<div class="edit-org-user-dialog__root">
  <h1 mat-dialog-title class="headline">Edit User</h1>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field class="full-width">
        <mat-label>Display name</mat-label>
        <input type="text" matInput inputmode="text" placeholder="e.g., Jane Smith" formControlName="name" />
        @if (name.invalid && name.touched) {
          <mat-error>{{ getNameErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Account status</mat-label>
        <input matInput formControlName="status" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>DISCARD</button>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="form.invalid">SAVE</button>
  </mat-dialog-actions>
</div>
